<div class="logo-container" [ngClass]="size">
  <div class="logo-icon">
    <svg [attr.width]="iconSize" [attr.height]="iconSize" viewBox="0 0 40 40" fill="none">
      <!-- Abstract blue icon with concentric wavy shapes -->
      <circle cx="20" cy="20" r="18" fill="#3b82f6" opacity="0.9"/>
      <circle cx="20" cy="20" r="14" fill="#3b82f6" opacity="0.7"/>
      <circle cx="20" cy="20" r="10" fill="#3b82f6" opacity="0.5"/>
      <circle cx="20" cy="20" r="6" fill="#3b82f6" opacity="0.3"/>
      <!-- Wavy/curved elements -->
      <path d="M8 20 Q20 8 32 20" stroke="#60a5fa" stroke-width="2" fill="none" opacity="0.8"/>
      <path d="M8 20 Q20 32 32 20" stroke="#60a5fa" stroke-width="2" fill="none" opacity="0.6"/>
      <path d="M12 16 Q20 12 28 16" stroke="#93c5fd" stroke-width="1.5" fill="none" opacity="0.7"/>
      <path d="M12 24 Q20 28 28 24" stroke="#93c5fd" stroke-width="1.5" fill="none" opacity="0.7"/>
    </svg>
  </div>
  <div *ngIf="showText" class="logo-text">iTrakSys</div>
</div> 